module.exports = {
    routes: [{
        path: '/events-popup',
        name: 'events-popup',
        meta:{
            permissions:['events.read']
        },
        component: () => import('./views/popup.vue')
    }]
}